<script>
  export let title;
  export let onClose = () => {};
</script>

<div class="title-container">
  <div class="title">
    {#if title}
      {title}
    {:else}
      <slot />
    {/if}
  </div>
  <button class="close-button" on:click={onClose}>×</button>
</div>

<style>
  .title-container {
    position: sticky;
    top: 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-bottom: 1px solid #ddd;
    z-index: 10;
  }

  .title {
    font-weight: bold;
    flex-grow: 1;
    font-size: 24px;
    color: #888888;
    line-height: 1;
  }

  .close-button {
    background: transparent;
    border: none;
    font-size: 32px;
    cursor: pointer;
    line-height: 1;
    color: #888;
  }

  .close-button:hover {
    color: #000;
  }
</style>
